import React from 'react';

import PoweredByZf from './footer_powered_by_zf.jsx';
import CustomFooter from './custom_footer.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const FooterWrapperUi_ViewerVersion1 = (props)=>
  <div { ...props } />;

const FooterWrapperUi_ViewerVersion2 = (props)=>
  <footer { ...props } />;

const FooterWrapperUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <FooterWrapperUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <FooterWrapperUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

const Footer = ({ footerHtml }) => (
  <FooterWrapperUi className="footer">
    <PoweredByZf />
    {
      footerHtml &&
        <CustomFooter footerHtml={footerHtml} />
    }
  </FooterWrapperUi>
);

export default Footer;
